import { render } from "./App.vue?vue&type=template&id=0f8f74e4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0f8f74e4&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Devices_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__